import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import defaultLogo from '../images/logo.png';
import { pedirBootstrap } from './DataContext';

const LogoContext = createContext({ logo: defaultLogo, cargarLogo: () => {} });

export function LogoProvider({ children }) {
    const [logo, setLogo] = useState(defaultLogo);

    const cargarLogo = useCallback(() => {
        pedirBootstrap(true)
            .then(data => {
                const contacto = data?.contacto;
                const item = Array.isArray(contacto) ? contacto[contacto.length - 1] : contacto;
                if (item?.logo) setLogo(item.logo);
            })
            .catch(() => {});
    }, []);

    useEffect(() => {
        cargarLogo();
    }, [cargarLogo]);

    return (
        <LogoContext.Provider value={{ logo, cargarLogo }}>
            {children}
        </LogoContext.Provider>
    );
}

export function useLogo() {
    return useContext(LogoContext);
}
